import { ReturnShipmentErrorCodesZodSchema } from "@redotech/redo-model/return-shipment-types";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const dismissCreateShipmentFailure = {
  name: "dismissCreateShipmentFailure" as const,
  input: z.object({
    returnId: zExt.objectId(),
    errorCode: ReturnShipmentErrorCodesZodSchema.nullable(),
  }),
  output: z.null(),
};
